import { useEffect, useState } from 'react';
import DeleteIcon from '../../../assets/Modals/DeleteIcon';
import DisableCommentsIcon from '../../../assets/Modals/DisableCommentsIcon';
import EditIcon from '../../../assets/Modals/EditIcon';
import SaveIcon from '../../../assets/Modals/SaveIcon';
import StarIcon from '../../../assets/Modals/StartIcon/StarIcon';
import { useAuth } from '../../../contexts/auth';
import { Button, Container } from './styles';

type PostModalProps = {
  open: boolean;
  authorUsername: string;
  onAction: any;
};

export default function PostOptionsModal({ open, authorUsername, onAction }: PostModalProps) {
  const { user } = useAuth();
  const [isOwner, setIsOwner] = useState<boolean>(user?.username === authorUsername);
  useEffect(() => {
    if (user && user.username) {
      setIsOwner(user?.username === authorUsername)
    }
  }, [user?.username, authorUsername])

  return (
    <>
      {open && (
        <Container>
          {isOwner ? (
            <>
              <Button delete={false}>
                <StarIcon />
                Destacar no perfil
              </Button>
              <Button delete={false}>
                <EditIcon />
                Editar
              </Button>
              <Button delete={false}>
                <DisableCommentsIcon />
                Desativar comentários
              </Button>
              <Button delete={true} onClick={() => onAction('delete')}>
                <DeleteIcon />
                Excluir
              </Button>
            </>
          ) : (
            <>
              <Button delete={false}>
                <SaveIcon />
                Salvar na coleção
              </Button>
              <Button delete={false}>
                <EditIcon />
                Deixar de seguir
              </Button>
              <Button delete={true}>
                <DeleteIcon />
                Denunciar
              </Button>
            </>
          )}
        </Container>
      )}
    </>
  );
}